import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_ENDPOINT_SOCKET || 'http://localhost:5000';
const socket = io(URL);

export default socket;
